import React, { useState } from 'react';
import { useCartContext } from '../../context/cart/cart_context';
import styled from "styled-components";
import CartItem from "../../components/course/CartItem";
import {MdClear} from "react-icons/md";
import Navbar from '../../components/course/Navbar';
import Sidebar from '../../components/course/Sidebar';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AppBar2 from '../../newTestPreo/courses/appbar/AppBar2';
import { Box } from '@mui/material';
import AppBarComponent from '../../newTestPrepDesign/component/AppBar';

 const CartPage = () => {
  const {cart: cartItems, total_items, total_amount, clearCart} = useCartContext();
  const { firstName, lastName, email, role } = useSelector((state) => state.user)
    const navigate = useNavigate()

  if(cartItems.length < 1){
    return (
      <>
      <AppBarComponent />
      <Box mt={20}>
      <NotFoundWrapper>
        <div className='container'>No items found in the cart.</div>
      </NotFoundWrapper>
      </Box>
      </>
    )
  }

  const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = src

        script.onload = () => {
            resolve(true)
        }

        script.onerror = () => resolve(false)

        document.body.appendChild(script)
    })
}

const displayRazorpay = async (amount) => {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

    if(!res) {
        alert('You are offline,,Failed to load Razorpay')
        return
    }

    const options = {
        key: "rzp_test_zlurYuGZnREg1E",
        amount: amount * 100, // Razorpay amount is in paise (e.g., multiply by 100 for rupees)
        currency: 'INR', // Change currency code as per your requirement
        name: 'Course Payment',
        description: 'Payment for course enrollment',
        image: 'https://www.siecmigration.com/assets/images/logo-siec.webp', // Replace with your logo URL
        handler: function (response) {
          // Handle the successful payment response here
          alert('Payment successful')
          
          navigate('/studentdashboard')
        },
        prefill: {
          name: {firstName}, // Prepopulate customer name if available
          email: {email}, // Prepopulate customer email if available
        },
        theme: {
          color: '#F37254', // Customize the theme color as per your requirement
        },
      };

    
      const razorpay = new window.Razorpay(options);
      razorpay.open();
    }

  return (
    <>
    <AppBarComponent />
    <Box mt={20}>
    <CartWrapper>
      <div className='container'>
        <div className='cart-pg-title fw-8 fs-24'>
          <h3>Shopping Cart</h3>
        </div>
        <div className='cart-grid grid'>
          {/* card grid left */}
          <div className='cart-grid-left'>
            <div className='flex flex-wrap flex-between'>
              <div className='cart-count-info'>
                <span className='fw-7 fs-20'>{total_items}</span> Package in Cart
              </div>
              <button type="button" className='cart-clear-btn flex fs-15 fw-6 text' onClick={() => clearCart()}>
                <MdClear className='text-pink' />
                <span className='d-inline-block text-pink'>Clear All</span>
              </button>
            </div>

            <div className='cart-items-list grid'>
              {
                cartItems.map(cartItem => {
                  return (
                    <CartItem
                      key={cartItem.courseID}
                      cartItem={cartItem}
                    />
                  )
                })
              }
            </div>
          </div>
          {/* end of grid left */}
          {/* cart grid right */}
          <div className='cart-grid-right'>
            <div className='cart-total'>
              <span className='d-block fs-18 fw-6'>Total:</span>
              <div className='cart-total-value fw-8'>Rs{total_amount}</div>
              <button type="button" className='checkout-btn bg-purple text-white fw-6' onClick={() => displayRazorpay(total_amount)}>Checkout</button>
            </div>
          </div>
          {/* end of cart grid right */}
        </div>
      </div>
    </CartWrapper>
    </Box>
    </>
  )
}

const NotFoundWrapper = styled.div`
  padding: 30px 0;
  font-weight: 600;
  font-size:30px;
`;

const CartWrapper = styled.div`
  padding: 30px 0;
  .card-pg-title{
    padding: 20px 0 6px 0;
  }
  .cart-grid{
    row-gap: 40px;
    .cart-grid-left{
      margin-bottom: 30px;
    }

    .cart-clear-btn{
      span{
        margin-left: 6px;
      }
    }

    .cart-items-list{
      margin-top: 20px;
      row-gap: 12px;
    }
    .cart-total-value{
      font-size: 34px;
    }
    .checkout-btn{
      padding: 14px 28px;
      letter-spacing: 1px;
      margin-top: 12px;
      transition: var(--transition);

      &:hover{
        background-color: var(--clr-dark);
      }
    }
    .cart-total{
      padding-bottom: 50px;
    }

    @media screen and (min-width: 992px){
      grid-template-columns: 70% 30%;;
      column-gap: 32px;
    }
  }
`

export default CartPage;
